import estornar from '@/core/store/item-pedido/estorno/estornar'
import detalhes from '@/core/store/item-pedido/estorno/detalhes-estorno'

export default {
	modules: {
		estornar,
		detalhes,
	},
}
